var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 3.668a1 1 0 0 1 1 1 2 2 0 1 0 4 0 1 1 0 0 1 1-1h5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h5Zm-5 2v3h1a2 2 0 0 1 2 2v9h10v-9a2 2 0 0 1 2-2h1v-3h-4.126a4.002 4.002 0 0 1-7.748 0H4Z"
  })));
};

export default SvgProducts;